function extractJanUrl(imagePath: any): any {
  if (!imagePath) {
    return imagePath;
  }

  const updatedPath = imagePath?.replace(/\/(s_)?([^/]+)$/, "/$2");
  return updatedPath;
}

export default extractJanUrl;
